<template>
  <div id="box">
    <div class="content">
      <p style="text-align: left;padding-top: 30px;"><el-button plain @click="isback">返回</el-button></p>
      <div class="header">
        <div class="t1">
          <p>{{datalist.project_name}}</p>
          <!-- <p>兰海国家高速公路重庆至遵义段（贵州境）扩容工程</p> -->
        </div>
        <div class="t2">
          <p>电子公文</p>
        </div>
      </div>
      
      <div class="c-title">
        <p style="text-align: right; padding: 10px;"><span>发文字号：</span>{{dataobj.BH}}</p>
        <el-row :gutter="20" class="box">
          <el-col :span="12" class="common"><span>公文类型：</span>{{dataobj.GWLX}}</el-col>
          <el-col :span="12" class="common"><span>紧急程度：</span>{{dataobj.JJCD}}</el-col>
          <el-col :span="24" class="common"><span>文件标题：</span>{{dataobj.Title}}</el-col>
          <el-col :span="24" class="common"><span>主题词：</span>{{dataobj.ZTC}}</el-col>
          <el-col :span="24" class="common"><span>主送单位/人：</span>{{dataobj.zsperson}}</el-col>
          <el-col :span="24" class="common"><span>抄送单位/人：</span>{{dataobj.csperson}}</el-col>
          <el-col :span="12" class="common"><span>拟稿人：</span>{{dataobj.QFRMC}}</el-col>
          <el-col :span="12" class="common"><span>拟稿部门：</span>{{dataobj.QFDW}}</el-col>
          <el-col :span="12" class="common"><span>发文日期：</span>{{dataobj.QFSJ}}</el-col>
          <el-col :span="12" class="common"><span>发文份数：</span>{{dataobj.FWFS}}</el-col>
        </el-row>
      </div>

      <div class="c-content">
        <p class="c-p"><span>正文</span></p>
        <div v-if="dataobj.zsfile" class="file">
          <p v-for="(item, index) in dataobj.zsfile" :key="index"><el-link :underline="false" type="primary" :href="item">{{item}}</el-link></p>
        </div>
      </div>
      <div class="c-file">
        <p><span>附件</span></p>
        <div v-if="dataobj.csfile" class="c-c">
          <p v-for="(item, index) in dataobj.csfile" :key="index"><el-link :underline="false" type="primary" :href="item">{{item}}</el-link></p>
        </div>
      </div>
      <div class="footer">
        <p>
          <el-button plain v-show="dataobj.doc_status_name === '未发送'" @click="sent">发送</el-button>
          <!-- <el-button type="primary">生成Word文档</el-button> -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { FindGWJLXQ, aGW } from '@/api/api';
export default {
  name: 'taskdetail',
  components: {
  },
  data() {
    return {
      dataobj: {}
    }
  },
  watch: {
  },
  created() {
    this.getData(this.$route.query.data.id)
  },
  methods: {
    getData(id) {
      FindGWJLXQ({id}).then(res => {
        // console.log(res)
        if (res.data.ret !== 'error') {
          const data = JSON.parse(res.data.data)
          console.log(data)
          const arr1 = this.personapi(data.GLYH)
          const arr2 = this.fileapi(data.ZWFJ, data.CSFJ)
          this.dataobj = data
          this.dataobj.zsperson = arr1[0]
          this.dataobj.csperson = arr1[1]
          this.dataobj.zsfile = arr2[1]
          this.dataobj.csfile = arr2[1]
        } else {
          this.$message(res.data.msg);
        }
      })
    },
    //主送，抄送人员
    personapi(list) {
      // console.log(list)
      let array1 = []
      let array2 = []

      list.forEach(item => {
        if(item.RELATION_TYPE === 0) {
          array1.push(item.YHMC)
        } else {
          array2.push(item.YHMC)
        }
      })
      return [array1.join(','), array2.join(',')]
    },
    //附件
    fileapi(data1, data2) {
      let array1 = data1.split('http')
      array1.shift()
      array1.forEach((item, index) => {
        array1[index] = `http${item}`
      })
      let array2 = data2.split('http')
      array2.shift()
      array2.forEach((item, index) => {
        array2[index] = `http${item}`
      })
      return [array1, array2]
    },

    sent() {
      aGW({id: this.$route.query.data.id, GWZT: 1}).then(res => {
        if (res.data.ret !== 'error') {
          this.$message('发送成功！')
          this.getData(this.$route.query.data.id)
          // console.log(res)
        } else {
          this.$message(res.data.msg);
        }
      })
    },

    isback() {
      this.$router.push({
        path: '/eod/gotask'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#box {
  padding: 20px;
  & /deep/ .el-dialog__wrapper {
    .el-dialog {
      .el-dialog__header {
        background: #0F3F6C;
      }
      .el-dialog__body{
        background: #123054;
        // height: 400px;
      }
      .el-dialog__footer {
        background: #123054;
        text-align: right;
        .el-button {
          color: #fff;
          width: 150px;
          border: 1px solid rgba(33,150,227,0.50);
          border-radius: 4px;
          margin: 0 10px;
        }
      }
    }
  }
  & /deep/ .el-textarea {
    font-size: 18px !important;
    line-height: 26px !important;
  }
}
.com {
  display: flex;
  justify-content: flex-start;
}
.content {
  width: 100%;
  height: 100%;
  padding: 0 100px;
  background: rgba(50,58,82,0.25);
  border: 1px solid rgba(122,139,168,0.15);
  border-radius: 8px;
  opacity: 0.85;
  & /deep/ .el-button {
    color: #fff;
    width: 150px;
    border: 1px solid rgba(33,150,227,0.50);
    border-radius: 4px;
    margin: 0 10px;
  }
  .header {
    color: #FFFFFF;
    text-align: center;
    border-bottom: 1px dashed #AAB7CA;
    .t1 {
      margin: 30px 0;
      p {
        font-size: 22px;
        line-height: 16px;
        padding: 10px 0;
      }
    }
    .t2 {
      margin-bottom: 40px;
      p {
        font-size: 32px;
        line-height: 16px;
      }
    }
  }

  .c-title {
    // border: 1px solid hotpink;
    height: 320px;
    color: #ffffff;
    border-bottom: 1px dashed #AAB7CA;
    span {
      display: inline-block;
      width: 110px;
      color: #AAB7CA;
    }
    .box {
      padding: 10px 0;
      .common {
        padding: 10px 0;
      }
    }
  }

  .c-content {
    color: #FFFFFF;
    height: 300px;
    width: 100%;
    border-bottom: 1px dashed #AAB7CA;
    padding: 15px 0;
    .file {
      margin: 10px;
      p {
        padding: 5px;
      }
    }
  }
  .c-file {
    padding: 15px 0;
    color: #FFFFFF;
    height: 300px;
    width: 100%;
    border-bottom: 1px dashed #AAB7CA;
    .c-c {
      margin: 10px;
      p {
        padding: 5px;
      }
    }
  }
  .footer {
    padding: 35px 0;
    & /deep/ .el-button {
      color: #fff;
      width: 150px;
      border: 1px solid rgba(33,150,227,0.50);
      border-radius: 4px;
      margin: 0 10px;
    }
    p {
      text-align: right;
      padding-top: 10px;
    }
    & /deep/ .el-dialog__body{
      background: #123054;
      height: 1700px !important;
    }
  }

  .sel {
    margin-top: 30px;
    padding: 0 30px;
    & /deep/ .el-input__inner {
      border-radius: 6px;
    }
    & /deep/ .el-input, .el-select {
      margin: 2.5px 5px;
    }
    & /deep/ .el-select {
      margin-left: 0;
      margin-right: 10px;
    }
    & /deep/ .el-button {
      color: #fff;
      width: 150px;
      height: 36px;
      border: 1px solid rgba(33,150,227,0.50);
      border-radius: 4px;
      margin: 0 10px;
    }
  }
  .result {
    margin: 20px 0;
    & /deep/ .el-table--striped .el-table__body tr.el-table__row--striped td{
      // opacity: 1;
      background: rgba(65,147,222,.1);
    }
    & /deep/ .el-table__body tr:hover>td {
      background: rgba(0,175,255,.3);
    }
    & /deep/ .el-table--striped .el-table__body tr.el-table__row--striped:hover{
      background: rgba(0,175,255,.3);
    }
    & /deep/ .el-pagination .btn-prev{
      background: rgba(12,33,61,.1);
    }
    & /deep/ .el-pagination .el-pager li{
      background: rgba(12,33,61,.1);
    }
    & /deep/ .el-pagination .btn-next{
      background: rgba(12,33,61,.1);
    }
  }
}

</style>